export const ADD_MESSAGE = "ADD_MESSAGE";
export const USER_TYPING = "USER_TYPING";
export const ASSISTANT_RESPONDING = "ASSISTANT_RESPONDING";
export const ADD_BULK_MESSAGE = "ADD_BULK_MESSAGE";
export const DELETE_ALL_MESSAGES = "DELETE_ALL_MESSAGES";
export const SET_HAS_INITIALIZED_MESSAGES = "SET_HAS_INITIALIZED_MESSAGES";
export const ADD_SELECTED_VALUE = "ADD_SELECTED_VALUE";
export const REMOVE_SELECTED_VALUE = "REMOVE_SELECTED_VALUE";
export const REMOVE_ALL_SELECTED_VALUE = "REMOVE_ALL_SELECTED_VALUE";
export const DELETE_MESSAGES_KEEPING_INITIAL =
    "DELETE_MESSAGES_KEEPING_INITIAL";
export const APPEND_TO_LAST_MESSAGE = "APPEND_TO_LAST_MESSAGE";
export const ADD_ERROR_MESSAGE = "ADD_ERROR_MESSAGE";
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";
export const TOGGLE_CHAT_VISIBILITY = "TOGGLE_CHAT_VISIBILITY";
export const ADD_REPORT = "ADD_REPORT";
export const SET_ACTIVE_REPORT = "SET_ACTIVE_REPORT";
export const LOAD_REPORTS = "LOAD_REPORTS";
export const SET_CHAT_EXPANDED = "SET_CHAT_EXPANDED";
export const SET_TASK_STATUS_MESSAGE = "SET_TASK_STATUS_MESSAGE"
export const SHOW_CITATIONS = "SHOW_CITATIONS";
export const HIDE_CITATIONS = "HIDE_CITATIONS";
export const CLEAR_CITATIONS = "CLEAR_CITATIONS";
export const SET_HISTORY_METADATA = "SET_HISTORY_METADATA";
export const CLEAR_HISTORY_METADATA = "CLEAR_HISTORY_METADATA";
export const UPDATE_REPORT_MESSAGE = "UPDATE_REPORT_MESSAGE";
export const ENTER_SECTION_EDIT_MODE = "ENTER_SECTION_EDIT_MODE";
export const EXIT_SECTION_EDIT_MODE = "EXIT_SECTION_EDIT_MODE";
export const REVISE_SECTION_DRAFT_START = "REVISE_SECTION_DRAFT_START";
export const REVISE_SECTION_DRAFT_SUCCESS = "REVISE_SECTION_DRAFT_SUCCESS";
export const REVISE_SECTION_DRAFT_FAILURE = "REVISE_SECTION_DRAFT_FAILURE";
export const SAVE_SECTION_EDIT_START = "SAVE_SECTION_EDIT_START";
export const SAVE_SECTION_EDIT_SUCCESS = "SAVE_SECTION_EDIT_SUCCESS";
export const SAVE_SECTION_EDIT_FAILURE = "SAVE_SECTION_EDIT_FAILURE";
export const DELETE_REPORT_SECTION = "DELETE_REPORT_SECTION";
export const REORDER_REPORT_SECTIONS = "REORDER_REPORT_SECTIONS";
export const MOVE_SECTION_UP = "MOVE_SECTION_UP";
export const MOVE_SECTION_DOWN = "MOVE_SECTION_DOWN";
export const ADD_NEW_SECTION_INPUT = "ADD_NEW_SECTION_INPUT";
export const REMOVE_NEW_SECTION_INPUT = "REMOVE_NEW_SECTION_INPUT";
export const ADD_NEW_SECTION_START = "ADD_NEW_SECTION_START";
export const ADD_NEW_SECTION_SUCCESS = "ADD_NEW_SECTION_SUCCESS";
export const ADD_NEW_SECTION_FAILURE = "ADD_NEW_SECTION_FAILURE";
export const SAVE_NEW_SECTION_START = "SAVE_NEW_SECTION_START";
export const SAVE_NEW_SECTION_SUCCESS = "SAVE_NEW_SECTION_SUCCESS";
export const SAVE_NEW_SECTION_FAILURE = "SAVE_NEW_SECTION_FAILURE";
